import { FETCH_RENAMINGS_QUERY } from '~/gql/renamings/fetchRenamings'
import { UPDATE_RENAMINGS_MUTATION } from '~/gql/renamings/updateRenamings'
import { RenamingField, type Renaming } from '~/types/renaming'
import { buildObjectFromEntries } from '~/types/utils'

interface State {
  renamingsByField: { [key in RenamingField]?: string } | null
}

export const useRenamingStore = defineStore('renaming', {
  state: (): State => ({
    renamingsByField: null
  }),
  actions: {
    async loadRenamings() {
      const app = useNuxtApp()

      const renamings = (
        await app.$apiGqlClient.query({
          query: FETCH_RENAMINGS_QUERY
        })
      ).data.getRenamings as Renaming[]

      this.renamingsByField = buildObjectFromEntries(
        renamings.map(renaming => [renaming.field, renaming.naming])
      )
    },
    async updateRenamings(renamingsToUpdate: Renaming[]) {
      const app = useNuxtApp()

      await app.$apiGqlClient.mutate({
        mutation: UPDATE_RENAMINGS_MUTATION,
        variables: { renamings: renamingsToUpdate }
      })

      const newRenamingsByField = buildObjectFromEntries(
        renamingsToUpdate.map(renamingToUpdate => [
          renamingToUpdate.field,
          renamingToUpdate.naming
        ])
      )

      this.renamingsByField = {
        ...this.renamingsByField!,
        ...newRenamingsByField
      }
    }
  }
})
